import { initializeApp, type FirebaseOptions } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager
} from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const env = import.meta.env;

/**
 * True once .env.local has real values. Until then App renders the setup
 * screen instead of a broken sign-in button.
 */
export const isConfigured = Boolean(
  env.VITE_FIREBASE_API_KEY && env.VITE_FIREBASE_PROJECT_ID
);

const config: FirebaseOptions = {
  apiKey: env.VITE_FIREBASE_API_KEY || 'not-configured',
  authDomain: env.VITE_FIREBASE_AUTH_DOMAIN || 'not-configured',
  projectId: env.VITE_FIREBASE_PROJECT_ID || 'not-configured',
  storageBucket: env.VITE_FIREBASE_STORAGE_BUCKET || 'not-configured',
  messagingSenderId: env.VITE_FIREBASE_MESSAGING_SENDER_ID || '0',
  appId: env.VITE_FIREBASE_APP_ID || 'not-configured',
  measurementId: env.VITE_FIREBASE_MEASUREMENT_ID || undefined
};

export const app = initializeApp(config);
export const auth = getAuth(app);

export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: 'select_account' });

/**
 * Persistent cache means the app opens instantly from disk, reads mostly never
 * reach the network, and an expense added on a plane syncs when you land.
 */
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() })
});

export const storage = getStorage(app);

/**
 * Cloud Storage may require the Blaze plan on newer Firebase projects, so
 * receipts are opt-in. Everything else works on the free Spark plan.
 */
export const receiptsEnabled = env.VITE_ENABLE_RECEIPTS === 'true';
